import { Button, Input, Select } from "@arco-design/web-react";
import { RotateCcw, Search } from "lucide-react";

import type { DicMajorListFilters } from "../types";
import { dicMajorStatusOptions } from "../config";
import "../../../shared/ui/crmListPageLayout.css";
import "./DicMajorPage.css";

type DicMajorFilterPanelProps = {
  filters: DicMajorListFilters;
  errorMessage: string;
  onChange: (filters: DicMajorListFilters) => void;
  onReset: () => void;
  onSearch: () => void;
};

/** 标准专业筛选区。 */
export function DicMajorFilterPanel({
  filters,
  errorMessage,
  onChange,
  onReset,
  onSearch,
}: DicMajorFilterPanelProps) {
  return (
    <section
      className="crm-list-filter-panel"
      role="search"
      aria-label="标准专业筛选"
      data-layout="two-tier-responsive"
    >
      <div className="crm-list-filter-fields">
        <div className="crm-list-filter-primary">
          <label className="crm-list-field crm-list-field--lg">
            <span>关键词</span>
            <Input
              placeholder="名称、拼音码或别名"
              value={filters.keyword ?? ""}
              onChange={(keyword) => onChange({ ...filters, keyword })}
            />
          </label>
          <label className="crm-list-field crm-list-field--md">
            <span>专业大类</span>
            <Input
              placeholder="请输入专业大类"
              value={filters.majorCategory ?? ""}
              onChange={(majorCategory) => onChange({ ...filters, majorCategory })}
            />
          </label>
          <label className="crm-list-field crm-list-field--sm">
            <span>状态</span>
            <Select
              placeholder="全部状态"
              value={filters.isDisabled === undefined ? "" : String(filters.isDisabled)}
              onChange={(value) =>
                onChange({
                  ...filters,
                  isDisabled: value === "" ? undefined : value === "true",
                })
              }
            >
              {dicMajorStatusOptions.map((option) => (
                <Select.Option key={option.value} value={option.value}>
                  {option.label}
                </Select.Option>
              ))}
            </Select>
          </label>
        </div>
        {errorMessage ? <div className="dic-major-error">{errorMessage}</div> : null}
      </div>
      <div className="crm-list-filter-actions">
        <Button icon={<RotateCcw size={16} />} onClick={onReset}>
          重置
        </Button>
        <Button type="primary" icon={<Search size={16} />} onClick={onSearch}>
          搜索
        </Button>
      </div>
    </section>
  );
}
